import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QRCodeDetailRoutingModule } from './qr-code-detail-routing.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    QRCodeDetailRoutingModule,
  ]
})
export class QRCodeDetailModule { }
